import React, { Component } from "react";
import { PRODUCT_IMAGE_BASE_URL, setIS_NZ } from "../constants";
import style from "./EntryPoint.module.css";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import {
  fetchQuote,
  fetchCustomerGroup,
  fetchOpportunity,
  fetchPriceFlags
} from "../api";
import {
  addQuoteItemRaw,
  reset,
  setAdjustmentPeriod,
  setCanonCopyPlanType,
  setCanonFinancePayout,
  setCfaAmount,
  setCfaCcBw,
  setCfaCcBwAdjustClickChargePerMonthExclGst,
  setCfaCcBwMinimumMonthlyClickVolume,
  setCfaCcBwServiceCopyCost,
  setCfaCcBwExcessFinancedCopyCost,
  setCfaCcColour,
  setCfaCcColourAdjustClickChargePerMonthExclGst,
  setCfaCcColourMinimumMonthlyClickVolume,
  setCfaCcColourServiceCopyCost,
  setCfaCcColourExcessFinancedCopyCost,
  setPayoutInfo,
  setCustomerBillingAddressId,
  setCustomerGroupCode,
  setCustomerGroupId,
  setDerivedCustomerGroup,
  setFinanceSubtype,
  setFinanceTerm,
  setFinanceType,
  setInstalmentAmount,
  setInstalmentType,
  setIsFinanceConfigured,
  setIsMsa,
  setIsPrimary,
  setOpportunity,
  setOpportunityType,
  setOriginatorReference,
  setPayableIn,
  setPriceFlag,
  setValidPriceFlagList,
  setQid,
  setQuoteName,
  setResidualValue,
  setReturnUrl,
  setSfdcCustomerNumber,
  setSoftwareDeliveryAddressId,
  setSoftwareInstallationAddressId,
  setSaasDeliveryAddressId,
  setSaasInstallationAddressId,
  setTargetHardwareTotal,
  setTargetSoftwareTotal,
  setTargetSaasTotal,
  setTenderCode,
  setThirdPartyPayout,
  setTotalAmountFinanced,
  setTonerRecycleBox,
  setServiceTerm,
  setNzScanningMonthlyCharge,
  setTonerDeliveryCharge,
  setPerA3Charge,
  setMinimumMonthlyCharge,
  setDeferredPayment
} from "../redux/actions";
import { Table, Jumbotron, Button } from "react-bootstrap";
import { doesQuoteMatchOpportunity } from "../redux/selectors";

class EntryPoint extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoaded: false,
      altServer: "",
      caughtErrorMessage: ""
    };
  }

  async componentDidMount() {
    try {
      // We are processing a new quote from Salesforce, so clean up store first.
      this.props.reset();

      this.loadReturnUrl();

      const oid = this.props.match.params.oid || "";
      const qid = this.props.match.params.qid || "";

      await this.loadOpportunity(oid, qid);
      await this.loadValidPriceFlagList();

      if (qid) {
        await this.loadQuote(oid, qid);
      }
    } catch (error) {
      this.setState({ caughtErrorMessage: error.message });
    } finally {
      this.setState({ isLoaded: true });
    }
  }

  get message() {
    if (this.state.caughtErrorMessage) {
      return this.state.caughtErrorMessage;
    }

    if (this.state.altServer) {
      return (
        <>
          The quote was not found.
          <Button as="a" href={this.state.altServer} rel="noopener noreferrer">
            Try loading it from the old system (Magento 1)"
          </Button>
        </>
      );
    }

    // Finance type can not be empty and finance type "CFA" can not have empty sub type.
    if (
      !this.props.opportunity.FinanceType ||
      ((this.props.opportunity.FinanceType === "CFA" ||
        this.props.opportunity.FinanceType === "CFNZ") &&
        !this.props.opportunity.FinanceSubType)
    ) {
      return "Finance Type & Sub Type are not set in the opportunity. Please start a new quote from Salesforce with the Finance Type and Sub Type set.";
    }

    // MSA deals can not have PPP as finance subtype
    if (
      this.props.opportunity.IsMSA &&
      this.props.opportunity.FinanceType === "CFA" &&
      ["PPP_STANDARD", "PPP_COMBINED"].includes(
        this.props.opportunity.FinanceSubType
      )
    ) {
      return "Spark MSA quotes are not allowed for PPP finance deals.";
    }

    // Handle missing customer group
    if (!this.props.quote.customerGroupId) {
      return this.props.quote.isMsa
        ? `No price list association found, please check with the Product Marketing team to map MSA price list with account ${this.props.quote.sfdcCustomerNumber}.`
        : "No matching price list found for your opportunity/quote.";
    }

    // The CBA government is not allowed to use c2390 tender code
    /* if (
      this.props.opportunity.TenderCode &&
      this.props.opportunity.TenderCode.toUpperCase() === "C2390" &&
      this.props.opportunity.OpportunityType.toUpperCase() === "GOVERNMENT"
    ) {
      return "CBA Government is not authorized to create quotes for C2390 tender codes. Please change the tender code and try again.";
    } */

    if (!this.props.doesQuoteMatchOpportunity) {
      return (
        <div>
          <p>
            The key attributes in your opportunity had changed since your quote
            was saved. To edit the quote, please update your opportunity. You
            can also create a quote.
          </p>
          <Table>
            <thead>
              <tr>
                <th />
                <th>Opportunity</th>
                <th>Quote</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Opp Type</th>
                <td>{this.props.opportunity.OpportunityType}</td>
                <td>{this.props.quote.opportunityType}</td>
              </tr>
              <tr>
                <th>Tender Code</th>
                <td>{this.props.opportunity.TenderCode}</td>
                <td>{this.props.quote.tenderCode}</td>
              </tr>
              <tr>
                <th>Is MSA</th>
                <td>{this.props.opportunity.IsMSA ? "Yes" : "No"}</td>
                <td>{this.props.quote.isMsa ? "Yes" : "No"}</td>
              </tr>
              <tr>
                <th>Customer No.</th>
                <td>{this.props.opportunity.CustomerNumber}</td>
                <td>{this.props.quote.sfdcCustomerNumber}</td>
              </tr>
            </tbody>
          </Table>
        </div>
      );
    }

    return "";
  }

  loadReturnUrl() {
    const returnUrl =
      decodeURIComponent(this.props.match.params.returnUrl) ||
      process.env.REACT_APP_SFDC_LOGIN_URL;

    this.props.setReturnUrl(returnUrl);
  }

  async loadValidPriceFlagList() {
    const validPriceFlagList = await fetchPriceFlags(
      this.props.isMsa,
      this.props.opportunityType
    );
    this.props.setValidPriceFlagList(validPriceFlagList);
  }

  async loadOpportunity(oid, qid) {
    const opportunity = await fetchOpportunity(oid, qid);

    this.props.setOpportunity(opportunity);
    setIS_NZ(opportunity.OpportunityType);

    //region: Set the default values on the key fields in the new quote
    this.props.setOpportunityType(opportunity.OpportunityType);
    this.props.setTenderCode(opportunity.TenderCode);
    this.props.setIsMsa(opportunity.IsMSA);
    this.props.setSfdcCustomerNumber(opportunity.CustomerNumber);

    // "isPrimary" defaults to true if no primary quote exists yet.
    this.props.setIsPrimary(!opportunity.HasPrimaryQuote);

    this.props.setFinanceType(opportunity.FinanceType);
    this.props.setFinanceSubtype(opportunity.FinanceSubType);

    // Consider the financed is configured if the quote is new and is MSA
    this.props.setIsFinanceConfigured(opportunity.IsMSA);
    //endregion

    const customGroup = await fetchCustomerGroup(
      opportunity.IsMSA,
      opportunity.CustomerNumber,
      opportunity.OpportunityType,
      opportunity.TenderCode
    );

    this.props.setDerivedCustomerGroup(customGroup);

    // Set the default customer group in quote
    this.props.setCustomerGroupId(customGroup.id);
    this.props.setCustomerGroupCode(customGroup.code);
  }

  async loadQuote(oid, qid) {
    const response = await fetchQuote(oid, qid);

    if (response.quote) {
      this.loadRawQuoteItems(response.quote_items);

      // Restore the quote after the quote items so the target prices can be updated.
      // See setTargetHardwareTotal() & setTargetSoftware().
      this.loadRawQuote(response.quote);
    } else {
      this.setState({ altServer: response.alt_server });
    }
  }

  loadRawQuote(rawQuote) {
    // Restore the quote in Redux store
    //region ID & Name
    this.props.setQid(rawQuote.qid);
    this.props.setQuoteName(rawQuote.quote_name);
    this.props.setTonerRecycleBox(rawQuote.is_toner_recycle);
    this.props.setServiceTerm(rawQuote.service_term);
    //endregion

    if (rawQuote.customer_group_id) {
      // Customer Group ID can be empty for old quotes,
      // so we don't overwrite it here and let it fallback to the one from opportunity.
      this.props.setCustomerGroupId(rawQuote.customer_group_id);
      this.props.setCustomerGroupCode(rawQuote.customer_group_code);
    }

    this.props.setOpportunityType(rawQuote.opportunity_type);

    if (rawQuote.tender_code) {
      // Tender Code can be empty for old quotes,
      // so we don't overwrite it here and let it fallback to the one from opportunity.
      this.props.setTenderCode(rawQuote.tender_code);
    }

    this.props.setIsMsa(rawQuote.is_msa);

    if (rawQuote.sfdc_customer_number) {
      // SFDC Customer Number can be empty for old quotes,
      // so we don't overwrite it here and let it fallback to the one from opportunity.
      this.props.setSfdcCustomerNumber(rawQuote.sfdc_customer_number);
    }

    this.props.setPriceFlag(rawQuote.price_flag);
    this.props.setIsPrimary(rawQuote.is_primary);

    //region Finance
    //region Common Finance Fields
    this.props.setFinanceType(rawQuote.finance_type);
    this.props.setOriginatorReference(rawQuote.originator_reference);
    this.props.setFinanceSubtype(rawQuote.finance_subtype);
    this.props.setCfaAmount(rawQuote.cfa_amount);
    this.props.setTotalAmountFinanced(rawQuote.total_amount_financed);
    this.props.setCanonFinancePayout(rawQuote.canon_finance_payout);
    this.props.setThirdPartyPayout(rawQuote.third_party_payout);
    this.props.setDeferredPayment(rawQuote.deferred_payment);
    if (rawQuote.finance_type !== "CASH") {
      this.props.setServiceTerm(Number(rawQuote.finance_term));
    }
    this.props.setFinanceTerm(Number(rawQuote.finance_term));
    this.props.setInstalmentAmount(rawQuote.instalment_amount);
    this.props.setInstalmentType(rawQuote.instalment_type);
    this.props.setPayableIn(rawQuote.payable_in);
    this.props.setIsFinanceConfigured(
      (rawQuote.finance_type === "CFA" || rawQuote.finance_type === "CFNZ") &&
        (rawQuote.is_msa || Boolean(rawQuote.originator_reference))
    );
    //endregion

    // Lease Only
    this.props.setResidualValue(rawQuote.residual_value);

    //region PPP Only
    this.props.setAdjustmentPeriod(rawQuote.adjustment_period);
    this.props.setCanonCopyPlanType(rawQuote.canon_copy_plan_type);

    this.props.setCfaCcBw(rawQuote.cfa_cc_b_w);
    this.props.setCfaCcBwAdjustClickChargePerMonthExclGst(
      rawQuote.cfa_cc_b_w_adjust_click_charge_per_month_excl_gst
    );
    this.props.setCfaCcBwMinimumMonthlyClickVolume(
      rawQuote.cfa_cc_b_w_minimum_monthly_click_volume
    );
    this.props.setCfaCcBwServiceCopyCost(rawQuote.cfa_cc_b_w_service_copy_cost);
    //TODO: PPP_PMP > set the value as entry point after backend
    this.props.setCfaCcBwExcessFinancedCopyCost(
      rawQuote.cfa_cc_b_w_excess_financed_copy_cost
    );
    this.props.setCfaCcColourExcessFinancedCopyCost(
      rawQuote.cfa_cc_colour_excess_financed_copy_cost
    );

    this.props.setCfaCcColour(rawQuote.cfa_cc_colour);
    this.props.setCfaCcColourAdjustClickChargePerMonthExclGst(
      rawQuote.cfa_cc_colour_adjust_click_charge_per_month_excl_gst
    );
    this.props.setCfaCcColourMinimumMonthlyClickVolume(
      rawQuote.cfa_cc_colour_minimum_monthly_click_volume
    );
    this.props.setCfaCcColourServiceCopyCost(
      rawQuote.cfa_cc_colour_service_copy_cost
    );
    //endregion

    //payout table
    this.props.setPayoutInfo(rawQuote.payout_info);

    //region Software Addresses and Billing Address
    this.props.setSoftwareDeliveryAddressId(rawQuote.sw_delivery_address_id);
    this.props.setSoftwareInstallationAddressId(
      rawQuote.sw_installation_address_id
    );

    //region SaaS Addresses and Billing Address
    this.props.setSaasDeliveryAddressId(rawQuote.saas_delivery_address_id);
    this.props.setSaasInstallationAddressId(
      rawQuote.saas_installation_address_id
    );

    this.props.setCustomerBillingAddressId(
      rawQuote.customer_billing_address_id
    );
    //endregion

    //region Totals
    this.props.setTargetSoftwareTotal(rawQuote.total_software);
    this.props.setTargetHardwareTotal(rawQuote.total_hardware);
    this.props.setTargetSaasTotal(rawQuote.total_saas);
    //endregion
  }

  loadRawQuoteItems(rawQuoteItems) {
    rawQuoteItems
      .map(
        ({
          is_software,
          is_hardware,
          is_saas,
          cc_b_w,
          default_cc_b_w,
          user_click_volume_bw,
          cc_campaigns,
          cc_colour,
          default_cc_colour,
          user_click_volume_colour,
          default_cfa_cost_per_thousand,
          default_mds_cost,
          default_term,
          delivery_address_id,
          exclude_from_margin_split,
          flat_monthly_charge,
          image,
          installation_address_id,
          is_regional,
          purchase_orders,
          cost_centers,
          key,
          name,
          msa_price_flag,
          msa_payable_method,
          msa_instalment_frequency,
          msa_metro_click_charge_bw,
          msa_metro_click_charge_colour,
          msa_regional_click_charge_bw,
          msa_regional_click_charge_colour,
          options,
          price,
          product_id,
          qty,
          scan_charge,
          scanning_monthly_charge,
          sku,
          subscription_target_charge_value,
          subscription_term,
          subscription_user_num,
          target_cfa_cost_per_thousand,
          target_mds_cost,
          target_price,
          target_term,
          trade_ins,
          type,
          under_warranty,
          nz_minimum_monthly_charge,
          nz_per_a3_charge,
          nz_scanning_monthly_charge,
          nz_toner_delivery_charge,
          saas_identifier_label,
          saas_identifier_value,
          finance_type
        }) => {
          let nzPerA3ChargeValue = null;
          if (nz_per_a3_charge !== null) {
            const perA3Key = Object.entries(nz_per_a3_charge);
            nzPerA3ChargeValue = perA3Key[0][0];
          }
          return {
            ccBw: cc_b_w,
            defaultCcBw: Number(default_cc_b_w),
            userClickVolumeBw: Number(user_click_volume_bw),
            ccCampaigns: cc_campaigns || [],
            ccColour: cc_colour,
            defaultCcColour: Number(default_cc_colour),
            userClickVolumeColour: Number(user_click_volume_colour),
            costCenters: cost_centers,
            deliveryAddressId: delivery_address_id,
            excludeFromMarginSplit: exclude_from_margin_split,
            flatMonthlyCharge: flat_monthly_charge,
            image: image ? `${PRODUCT_IMAGE_BASE_URL}${image}` : null,
            installationAddressId: installation_address_id,
            isRegional: is_regional,
            isSoftware: is_software,
            isHardware: is_hardware,
            isSaas: is_saas,
            key,
            msaCfa: target_cfa_cost_per_thousand,
            msaDefaultCfa: default_cfa_cost_per_thousand,
            msaDefaultMdsCost: default_mds_cost,
            msaDefaultTerm: default_term,
            msaInstalmentFrequency: msa_instalment_frequency,
            msaMdsCost: target_mds_cost,
            msaPayableMethod: msa_payable_method,
            msaPriceFlag: msa_price_flag,
            msaTerm: target_term,
            msaMetroClickChargeBw: msa_metro_click_charge_bw,
            msaMetroClickChargeColour: msa_metro_click_charge_colour,
            msaRegionalClickChargeBw: msa_regional_click_charge_bw,
            msaRegionalClickChargeColour: msa_regional_click_charge_colour,
            name,
            price: type === "bundle" ? calculateItemPrice(options) : price,
            saasTargetPrice:
              type === "bundle"
                ? calculateItemSaasTargetPrice(options, subscription_term)
                : 0,
            saasMSP:
              type === "bundle"
                ? calculateItemSaasMSP(options, subscription_term)
                : 0,
            productId: product_id,
            purchaseOrders: purchase_orders,
            qty,
            scanCharge: scan_charge,
            scanningMonthlyCharge: scanning_monthly_charge,
            sku,
            subscriptionTargetChargeValue: subscription_target_charge_value,
            subscriptionTerm: subscription_term,
            subscriptionUserNum: subscription_user_num,
            targetPrice: target_price,
            type,
            underWarranty: under_warranty,
            tradeIns: trade_ins,
            minimumMonthlyCharge: nz_minimum_monthly_charge,
            perA3Charge: nzPerA3ChargeValue,
            perA3ChargeObject: nz_per_a3_charge,
            nzScanningMonthlyCharge: Number(nz_scanning_monthly_charge) || null,
            tonerDeliveryCharge: Number(nz_toner_delivery_charge) || null,

            existingTenantLabel: saas_identifier_label,
            existingTenantValue: saas_identifier_value,

            saasFinanceType: finance_type,

            options:
              options &&
              options.map(({ option_id, option_name, selections }) => ({
                optionName: option_name,
                optionId: option_id,
                selections: selections.map(
                  ({
                    exclude_from_margin_split,
                    includes_main_unit,
                    is_software,
                    is_hardware,
                    is_saas,
                    name,
                    product_id,
                    selection_id,
                    sku,
                    price,
                    qty,
                    inventory_qty,
                    target_price,
                    finance_type,
                    additional_linked_part
                  }) => ({
                    excludeFromMarginSplit: exclude_from_margin_split,
                    includesMainUnit: includes_main_unit,
                    isSoftware: is_software,
                    isHardware: is_hardware,
                    isSaas: is_saas,
                    name,
                    price,
                    productId: product_id,
                    qty,
                    inventory_qty: inventory_qty,
                    selectionId: selection_id,
                    sku,
                    targetPrice: target_price,
                    financeType: finance_type,
                    additionalLinkedPart: (additional_linked_part || "")
                      .trim()
                      .split(",")
                      .filter(Boolean)
                  })
                )
              })),

            isTheSameAddress:
              delivery_address_id[0] &&
              delivery_address_id.every(
                addrId => addrId === delivery_address_id[0]
              ) &&
              installation_address_id.every(
                addrId => addrId === delivery_address_id[0]
              ) &&
              is_regional.every(isRegional => isRegional === is_regional[0]),
            isTheSamePurchaseOrder:
              purchase_orders.length > 1 &&
              purchase_orders.every(
                (value, index, array) => value === array[0]
              ),
            isTheSameCostCenter:
              cost_centers.length > 1 &&
              cost_centers.every((value, index, array) => value === array[0])
          };
        }
      )
      .forEach(this.props.addQuoteItemRaw);
  }

  render() {
    return this.state.isLoaded ? (
      this.message ? (
        <div className={style.root}>
          <Jumbotron>
            {this.message}

            <div>
              <Button
                as="a"
                href={this.props.returnUrl}
                rel="noreferrer noopener"
              >
                Return to Salesforce
              </Button>
            </div>
          </Jumbotron>
        </div>
      ) : (
        <Redirect to={this.props.quote.qid ? "/quote" : "/"} />
      )
    ) : null;
  }
}

const calculateItemPrice = options => {
  return options
    .flatMap(o =>
      // Get the total price under a single option
      o.selections
        .filter(s => !s.is_saas)
        .map(s => {
          // Get a single selection price
          return s.price * s.qty;
        })
    )
    .reduce((total, price) => total + price, 0);
};

const calculateItemSaasTargetPrice = (options, subscriptionTerm) => {
  return options
    .flatMap(o =>
      // Get the total price under a single option
      o.selections
        .filter(s => s.is_saas)
        .map(s => {
          // Get a single selection price
          return s.target_price * s.qty * subscriptionTerm;
        })
    )
    .reduce((total, price) => total + price, 0);
};
const calculateItemSaasMSP = (options, subscriptionTerm) => {
  return options
    .flatMap(o =>
      // Get the total price under a single option
      o.selections
        .filter(s => s.is_saas)
        .map(s => {
          // Get a single selection price
          return s.price * s.qty * subscriptionTerm;
        })
    )
    .reduce((total, price) => total + price, 0);
};

export default connect(
  state => {
    const { returnUrl, derivedCustomerGroup, opportunity, quote } = state;

    return {
      returnUrl,
      derivedCustomerGroup,
      opportunity,
      quote,
      doesQuoteMatchOpportunity: doesQuoteMatchOpportunity(state)
    };
  },
  {
    reset,
    addQuoteItemRaw,
    setFinanceType,
    setFinanceSubtype,
    setCanonCopyPlanType,
    setAdjustmentPeriod,
    setCanonFinancePayout,
    setCfaAmount,
    setTotalAmountFinanced,
    setCfaCcBw,
    setCfaCcBwAdjustClickChargePerMonthExclGst,
    setCfaCcBwMinimumMonthlyClickVolume,
    setCfaCcBwServiceCopyCost,
    setCfaCcBwExcessFinancedCopyCost,
    setCfaCcColour,
    setCfaCcColourAdjustClickChargePerMonthExclGst,
    setCfaCcColourMinimumMonthlyClickVolume,
    setCfaCcColourServiceCopyCost,
    setCfaCcColourExcessFinancedCopyCost,
    setPayoutInfo,
    setCustomerBillingAddressId,
    setCustomerGroupCode,
    setCustomerGroupId,
    setDerivedCustomerGroup,
    setOpportunityType,
    setTenderCode,
    setIsMsa,
    setSfdcCustomerNumber,
    setIsFinanceConfigured,
    setFinanceTerm,
    setInstalmentAmount,
    setInstalmentType,
    setIsPrimary,
    setOpportunity,
    setOriginatorReference,
    setPayableIn,
    setPriceFlag,
    setValidPriceFlagList,
    setQid,
    setQuoteName,
    setResidualValue,
    setReturnUrl,
    setSoftwareDeliveryAddressId,
    setSoftwareInstallationAddressId,
    setSaasDeliveryAddressId,
    setSaasInstallationAddressId,
    setTargetHardwareTotal,
    setTargetSoftwareTotal,
    setTargetSaasTotal,
    setThirdPartyPayout,
    setTonerRecycleBox,
    setServiceTerm,
    setNzScanningMonthlyCharge,
    setTonerDeliveryCharge,
    setPerA3Charge,
    setMinimumMonthlyCharge,
    setDeferredPayment
  }
)(EntryPoint);
